import {getCookie, setCookie} from '../Functions/Utilities';

export class RegionController {
  private readonly localeCookieName: string = 'locale';
  private readonly languageBannerElementSelector: string = '.js-language-banner';
  private readonly languageBannerActiveClass: string = 'header__languageBanner--active';
  private localeCookie;
  private readonly fallbackLocaleCookie = getCookie('ipLocale');
  private readonly languageAttribute: string | null | undefined;
  private readonly languageBannerElement: HTMLElement | null = document.querySelector(this.languageBannerElementSelector);
  private readonly languageBannerActiveDynamicClass: string = 'languageBanner__dynamicElement--active';
  private readonly languageBannerLangSelectActive: string = 'languageBanner__langSelect--active';
  private readonly languageBannerContainerHide: string = 'languageBanner__container--hide';
  private readonly bannerDynamicElements: NodeListOf<HTMLElement> | null = document.querySelectorAll('.js-language-banner-dynamic-element');
  private readonly languageBannerCloseElement: NodeListOf<Element> = document.querySelectorAll('.js-close-language-banner');
  private readonly languageSelectBack: HTMLElement | null = document.querySelector('.js-lang-select-back');
  private readonly languageBannerContainer: HTMLElement | null = document.querySelector('.js-language-banner-container');
  private readonly languageBannerLangSelect: HTMLElement | null = document.querySelector('.js-language-banner-lang-select');
  private readonly LanguageSwitchBtn: NodeListOf<HTMLSelectElement> | undefined = document.querySelectorAll('.js-toggle-language');

  constructor() {
    const lang = document.querySelector('html');
    if (lang) {
      this.languageAttribute = lang.getAttribute('lang');
    }
    /* eventListener to open language navigation */
    if (this.LanguageSwitchBtn) {
      const breakpoint = window.matchMedia('(max-width: 1180px)');

      this.LanguageSwitchBtn.forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          if (breakpoint.matches && this.languageBannerLangSelect && this.languageBannerContainer) {
            this.languageBannerContainer.classList.toggle(this.languageBannerContainerHide);
            this.languageBannerLangSelect.classList.toggle(this.languageBannerLangSelectActive);
          } else {
            if (this.languageBannerElement) {
              this.languageBannerElement.classList.remove(this.languageBannerActiveClass);
            }
            const languageMenu = document.querySelector('.js-header-lang-desktop') as HTMLElement;
            if (languageMenu) {
              languageMenu.style.display = 'block';
            }
          }

        });
      });
    }

    if (this.languageSelectBack) {
      this.languageSelectBack.addEventListener('click', () => {
        if (this.languageBannerLangSelect && this.languageBannerContainer) {
          this.languageBannerContainer.classList.toggle(this.languageBannerContainerHide);
          this.languageBannerLangSelect.classList.toggle(this.languageBannerLangSelectActive);
        }
      });
    }

    const languageMenuOptions = document.querySelectorAll('.js-header-lang li a');
    if (languageMenuOptions) {
      languageMenuOptions.forEach(el => {
        el.addEventListener('click', e => {
          const langMenuOption = el.getAttribute('hreflang');
          if (langMenuOption) {
            setCookie(this.localeCookieName, langMenuOption);
          }
        });
      });
    }

    this.checkLanguageAndRegion();
  }

  checkLanguageAndRegion() {
    this.localeCookie = getCookie(this.localeCookieName);
    let currentLanguageLocale: string = '';
    if (this.languageAttribute === 'x-default') {
      currentLanguageLocale = 'en';
    } else {
      if (this.languageAttribute) {
        currentLanguageLocale = this.languageAttribute;
      }
    }
    currentLanguageLocale = currentLanguageLocale.toLowerCase();
    if (this.localeCookie && this.localeCookie.toLowerCase() !== currentLanguageLocale) {
      if (this.languageBannerCloseElement) {
        this.languageBannerCloseElement.forEach((x) => {
            x.addEventListener('click', () => {
              /* set cookie for current language and close banner */
              setCookie(this.localeCookieName, currentLanguageLocale);
              if (this.languageBannerElement) {
                this.languageBannerElement.classList.remove(this.languageBannerActiveClass);
              }
              const breadcrumbElement: HTMLElement | null = document.querySelector('.js-breadcrumbs');
              if (breadcrumbElement) {
                breadcrumbElement.style.top = '';
              }
            });
          },
        );
      }
      /* only show text and buttons in language of set cookie */
      if (this.bannerDynamicElements) {
        this.bannerDynamicElements.forEach((element) => {
          if (element.dataset.region) {
            if (element && this.localeCookie && element.dataset.region === this.localeCookie) {
              element.classList.add(this.languageBannerActiveDynamicClass);
            }
          }
        });
      }

      /* show banner */
      if (this.languageBannerElement) {
        this.languageBannerElement.classList.add(this.languageBannerActiveClass);
      }
    } else if (this.fallbackLocaleCookie && this.localeCookie === null) {
      /* set cookie based on fallbackCookie ipLocale from BE */
      setCookie(this.localeCookieName, this.fallbackLocaleCookie);
      this.checkLanguageAndRegion();
    }
  }
}
